/* unplugin-vue-components disabled */import { render } from "./VideoComponentA.vue?vue&type=template&id=17462412&scoped=true"
import script from "./VideoComponentA.vue?vue&type=script&lang=js"
export * from "./VideoComponentA.vue?vue&type=script&lang=js"

import "./VideoComponentA.vue?vue&type=style&index=0&id=17462412&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Public\\object\\xvideos-frontend\\mysex\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17462412"]])

export default __exports__